module.exports = __WEBPACK_EXTERNAL_MODULE_serializers_glTF_2_0_index__;